import { render } from "./Revolution.vue?vue&type=template&id=ae07bd12&scoped=true"
import script from "./Revolution.vue?vue&type=script&lang=js"
export * from "./Revolution.vue?vue&type=script&lang=js"

import "./Revolution.vue?vue&type=style&index=0&id=ae07bd12&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae07bd12"]])

export default __exports__